import {req} from 'nanoajax.js'

import {AuthStore} from '../auth'

import Actions from './Actions'
import Constants from './Constants'

class ChannelService {
   constructor() {
      this._locks = {}
   }

   create(nid, data) {
      let payload = JSON.stringify(data),
         url = Constants.CHANNEL_URL + '/' + nid,
         headers = {
            Authorization:  AuthStore.signV1('POST', url, payload),
            'Content-Type': 'text/json'
         }

      return req.post(url, payload, headers).then(([resp, _httpreq]) => {
         Actions.create(nid, resp.key, resp)

         return resp
      })
   }

   update(nid, key, patch) {
      let payload = JSON.stringify(patch),
         url = Constants.CHANNEL_URL + '/' + nid + '/' + key,
         headers = {
            Authorization:  AuthStore.signV1('PUT', url, payload),
            'Content-Type': 'text/json'
         }

      return req.put(url, payload, headers).then(([resp, _httpreq]) => {
         Actions.update(nid, key, resp)

         return resp
      })
   }

   list(nid) {
      let url = Constants.CHANNEL_URL + '/' + nid,
         headers = {Authorization: AuthStore.signV1('GET', url, '')}

      if (!this._locks[url]) {
         this._locks[url] = req.get(url, null, headers).then(([resp, _httpreq]) => {
            Actions.list(nid, resp)
            delete this._locks[url]

            return resp
         })
      }

      return this._locks[url]
   }

   fetch(nid, key) {
      let url = Constants.CHANNEL_URL + '/' + nid + '/' + key,
         headers = {Authorization: AuthStore.signV1('GET', url, '')}

      if (!this._locks[url]) {
         this._locks[url] = req
            .get(url, null, headers)
            .then(([resp, _httpreq]) => {
               Actions.change(nid, key, resp)

               delete this._locks[url]

               return resp
            })
            .catch(err => {
               delete this._locks[url]
            })
      }

      return this._locks[url]
   }

   // chunked API, needs better stuff
   recv(nid, chan) {
      const url = Constants.CHANNEL_IO_URL + '/' + nid + '/' + chan,
         headers = {Authorization: AuthStore.signV1('GET', url, '')}

      req.get(url, null, headers).then(([resp, _httpreq]) => {
         Actions.io_recv(nid, chan, resp)

         return resp
      })
   }

   send(nid, chan, data) {
      const payload = JSON.stringify(patch),
         url = Constants.CHANNEL_IO_URL + '/' + nid + '/' + chan,
         headers = {Authorization: AuthStore.signV1('POST', url, payload)}

      req.post(url, payload, headers).then(([resp, _httpreq]) => {
         Actions.io_send(nid, chan, resp)

         return resp
      })
   }

   createToken(nid, chan, token) {
      const payload = JSON.stringify(patch),
         url = Constants.CHANNEL_TOKEN_URL + '/' + nid + '/' + chan,
         headers = {Authorization: AuthStore.signV1('POST', url, payload)}

      req.post(url, payload, headers).then(([resp, _httpreq]) => {
         Actions.token_create(nid, chan, resp)

         return resp
      })
   }

   revokeToken(nid, chan, token) {
      const payload = JSON.stringify(patch),
         url = Constants.CHANNEL_TOKEN_URL + '/' + nid + '/' + chan + '/' + token,
         headers = {Authorization: AuthStore.signV1('DELETE', url, payload)}

      req.delete(url, payload, headers).then(([resp, _httpreq]) => {
         Actions.token_revoke(nid, chan, resp)

         return resp
      })
   }

   listTokens(nid, chan) {
      let url = Constants.CHANNEL_TOKEN_URL + '/' + nid + '/' + chan,
         headers = {Authorization: AuthStore.signV1('GET', url, '')}

      if (!this._locks[url]) {
         this._locks[url] = req
            .get(url, null, headers)
            .then(([resp, _httpreq]) => {
               Actions.token_list(nid, key, resp)

               delete this._locks[url]

               return resp
            })
            .catch(err => {
               delete this._locks[url]
            })
      }

      return this._locks[url]
   }

   fetchToken(nid, chan, token) {
      let url = Constants.CHANNEL_TOKEN_URL + '/' + nid + '/' + key + '/' + token,
         headers = {Authorization: AuthStore.signV1('GET', url, '')}

      if (!this._locks[url]) {
         this._locks[url] = req
            .get(url, null, headers)
            .then(([resp, _httpreq]) => {
               Actions.token_change(nid, key, resp)

               delete this._locks[url]

               return resp
            })
            .catch(err => {
               delete this._locks[url]
            })
      }

      return this._locks[url]
   }
}

export default new ChannelService()



// WEBPACK FOOTER //
// lib/api/channel/Service.js